import { History } from 'history';
export const SET_OTP_EMAIL = 'bookingManager/SET_OTP_EMAIL';

export const REQUEST_OTP_EMAIL_REQUEST = 'bookingManager/REQUEST_OTP_EMAIL_REQUEST';
export const REQUEST_OTP_EMAIL_SUCCESS = 'bookingManager/REQUEST_OTP_EMAIL_SUCCESS';
export const REQUEST_OTP_EMAIL_FAILURE = 'bookingManager/REQUEST_OTP_EMAIL_FAILURE';
export const VERIFY_OTP_EMAIL_REQUEST = 'bookingManager/VERIFY_OTP_EMAIL_REQUEST';
export const VERIFY_OTP_EMAIL_SUCCESS = 'bookingManager/VERIFY_OTP_EMAIL_SUCCESS';
export const VERIFY_OTP_EMAIL_FAILURE = 'bookingManager/VERIFY_OTP_EMAIL_FAILURE';
export const SET_RESEND_TIMER = 'bookingManager/SET_RESEND_TIMER';
export const SET_OTP_CODE = 'bookingManager/SET_OTP_CODE';
export const RESET_OTP_SUBDOMAIN = 'bookingManager/RESET_OTP_SUBDOMAIN';

export type SetOtpEmailAction = ReturnType<typeof setOtpEmailAction>;
export const setOtpEmailAction = (email: string) => ({
  type: SET_OTP_EMAIL as typeof SET_OTP_EMAIL,
  email,
});

export type RequestOtpEmailRequestAction = ReturnType<typeof requestOtpEmailRequestAction>;
export const requestOtpEmailRequestAction = (itemUuid: string, history: History) => ({
  type: REQUEST_OTP_EMAIL_REQUEST as typeof REQUEST_OTP_EMAIL_REQUEST,
  itemUuid,
  history,
});

export type RequestOtpEmailSuccessAction = ReturnType<typeof requestOtpEmailSuccessAction>;
export const requestOtpEmailSuccessAction = (statusCode: number) => ({
  type: REQUEST_OTP_EMAIL_SUCCESS as typeof REQUEST_OTP_EMAIL_SUCCESS,
  statusCode,
});

export type RequestOtpEmailFailureAction = ReturnType<typeof requestOtpEmailFailureAction>;
export const requestOtpEmailFailureAction = (errors: string[]) => ({
  type: REQUEST_OTP_EMAIL_FAILURE as typeof REQUEST_OTP_EMAIL_FAILURE,
  errors,
});

export type VerifyOtpEmailRequestAction = ReturnType<typeof verifyOtpEmailRequestAction>;
export const verifyOtpEmailRequestAction = (itemUuid: string, history: History, email: string, otp: string) => ({
  type: VERIFY_OTP_EMAIL_REQUEST as typeof VERIFY_OTP_EMAIL_REQUEST,
  itemUuid,
  history,
  email,
  otp,
});

export type VerifyOtpEmailSuccessAction = ReturnType<typeof verifyOtpEmailSuccessAction>;
export const verifyOtpEmailSuccessAction = (statusCode: number) => ({
  type: VERIFY_OTP_EMAIL_SUCCESS as typeof VERIFY_OTP_EMAIL_SUCCESS,
  statusCode,
});

export type VerifyOtpEmailFailureAction = ReturnType<typeof verifyOtpEmailFailureAction>;
export const verifyOtpEmailFailureAction = (errors: string[]) => ({
  type: VERIFY_OTP_EMAIL_FAILURE as typeof VERIFY_OTP_EMAIL_FAILURE,
  errors,
});

export type SetResendTimerAction = ReturnType<typeof setResendTimerAction>;
export const setResendTimerAction = (time: number) => ({
  type: SET_RESEND_TIMER as typeof SET_RESEND_TIMER,
  time,
});

export type SetOtpCodeAction = ReturnType<typeof setOtpCodeAction>;
export const setOtpCodeAction = (otp: string) => ({
  type: SET_OTP_CODE as typeof SET_OTP_CODE,
  otp,
});

export type ResetOtpSubdomainAction = ReturnType<typeof resetOtpSubdomainAction>;
export const resetOtpSubdomainAction = () => ({
  type: RESET_OTP_SUBDOMAIN as typeof RESET_OTP_SUBDOMAIN,
});

export type OtpActions =
  | SetOtpEmailAction
  | RequestOtpEmailRequestAction
  | RequestOtpEmailSuccessAction
  | RequestOtpEmailFailureAction
  | VerifyOtpEmailRequestAction
  | VerifyOtpEmailSuccessAction
  | VerifyOtpEmailFailureAction
  | SetOtpCodeAction
  | SetResendTimerAction
  | ResetOtpSubdomainAction;